var HowItWorksSection = function () {
  var carouselSettings = {
    align: 'prev',
    autoInit: false,
    circular: false,
    bound: true,
    noPanelStyleOverride: false,
    useResizeObserver: false,
  }
  var carouselSelector = '#howItWorksCarousel'

  var flicking

  var handleResize = function () {
    var carouselWidth = $(carouselSelector).width()
    if (carouselWidth >= 1200 && flicking.initialized) {
      flicking.moveTo(0, 1)
      window.setTimeout(function () {
        flicking.destroy()
      }, 500)
      return
    }

    if (carouselWidth < 1200 && !flicking.initialized) {
      flicking.init()
    }
  }

  var init = function () {
    if ($(carouselSelector).length) {
      $(carouselSelector).ready(function () {
        flicking = new Flicking(carouselSelector, carouselSettings)

        flicking.on('ready', function () {
          flicking.addPlugins(new Flicking.Plugins.Arrow({
            prevElSelector: '.how-it-works-section__carousel__arrow--prev',
            nextElSelector: '.how-it-works-section__carousel__arrow--next'
          }))
          handleResize()
          window.addEventListener('resize', handleResize)
        })

        flicking.init()
      })
    }
  }

  return {
    init: init
  }
}()

UL.register(HowItWorksSection)
